import { Resource } from "@/types"
import { createResource } from "frappe-ui"
import { watch } from "vue"
import { useSelectedCustomer } from "./useCustomer"

const myPermissions: Resource = createResource({
  url: "bookings.ui.api.get_my_permissions",
});

watch(useSelectedCustomer(), () => myPermissions.reload());

export function usePermissions() {
  if (!myPermissions.fetched && !myPermissions.loading && !myPermissions.error) {
    myPermissions.reload();
  }
  return myPermissions;
}

export function hasPermission(perm: string) {
  return usePermissions().data?.[perm] ?? false;
}
